module.exports = __webpack_public_path__ + "img/icon-track-light-blue.81d2fb7b.svg";